
import {
    Box, Stack, FormControl, Select,
    MenuItem, InputLabel, Paper,
} from "@mui/material";
import { useState } from "react";
import ChargeBacksDetails from "./ChargeBacksDetails/ChargeBacksDetails";
import MerchantsDetails from "./MerchantsDetails/MerchantsDetails";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import ViewTransactionsRanges from "../../HelperFunctions/ViewTransactionsRanges";
import { useLoaderData } from "react-router-dom";
import { DateFormater, Loader } from "../../HelperFunctions/HelperFunctions";
import { handleExportFile } from "../../API/backendAPI";



const MerchantWidget = () => {
    const { headerCorporation, corporations, userPreference, Previlage } = useLoaderData();

    const exportList = [
        // { label: "PDF", value: "pdf" },
        { label: "Excel", value: "excel" }
    ];
    const viewTransaction = ViewTransactionsRanges();

    const [exportFile, setExportFile] = useState("export");
    // const [selectedProfitCenter, setSelectedProfitCenter] = useState({ ID: "select", Name: "Select profit center" });

    const [selectedProfitCenter, setSelectedProfitCenter] = useState({});
    const [selectedMerchantProvider, setSelectedMerchantProvider] = useState("0");
    const [date, setDate] = useState(null);
    const defaultOption =
        viewTransaction.find(opt => opt.date === "Past 90 Days") ||
        viewTransaction.find(opt => opt.date === "Range");
    const [dateRange, setDateRange] = useState(
        defaultOption ? [defaultOption.actualValue.start, defaultOption.actualValue.end] : [null, null]
    );
    const [pendingChargeBackDate, setPendingChargeBackDate] = useState(new Date());
    const [loading, setLoading] = useState(false);


    const handleExportFileChange = async (e) => {
        if (!headerCorporation) {
            enqueueSnackbar("Please select the corporation to proceed further", { variant: "warning" });
            return;
        };

        if (!Previlage?.[0].Create) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        }

        try {
            setLoading(true);

            const corpdetails = corporations.find(
                (item) => item.ID === headerCorporation
            );
            const year = date.getFullYear();
            const month = date.getMonth();
            const fromDate = new Date(year, month, 1);
            const toDate = new Date(year, month + 1, 0);

            const { chargeBackFromDate, chargeBackTodate } = getMonthRangeFrom(dateRange);
            const pChargeBackDate = new Date(pendingChargeBackDate);

            let exportPayload = {
                corporation_id: corpdetails.ID,
                corporation_name: userPreference.IsShowCorpLegalName === "true" ? corpdetails?.LegalName : corpdetails?.Name,
                pc_id: "",
                pc_name: "",
                from_date: DateFormater(fromDate),
                to_date: DateFormater(toDate),
                chargeback_from_date: chargeBackFromDate,
                chargeback_to_date: chargeBackTodate,
                as_of_date: DateFormater(pChargeBackDate)
            };

            const selectedFormat = e.target.value;

            if (selectedFormat === "pdf") {
                exportPayload = {
                    ...exportPayload,
                    html: document.documentElement.outerHTML
                };
            }

            setExportFile(selectedFormat);
            const endPoint = selectedFormat === "pdf" ? "generate_pdf_report" : "generate_excel_report";

            const { blob, headers } = await handleExportFile(endPoint, exportPayload);

            let filename = "Merchant Reconciliation Details";
            const disposition = headers.get("content-disposition");

            if (disposition) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match) filename = match[1];
            } else {
                filename += selectedFormat === "pdf" ? ".pdf" : ".xlsx";
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log("errorerror", error)
            enqueueSnackbar("Error while Export", { variant: "error" });
        } finally {
            setLoading(false);
            setExportFile("export");
        }
    };

    const getMonthRangeFrom = (dates) => {
        if (!dates || dates.length < 2) return;

        const [fromISO, toISO] = dates;

        const from = new Date(fromISO);
        const to = new Date(toISO);

        return {
            chargeBackFromDate: DateFormater(from),
            chargeBackTodate: DateFormater(to)
        };
    };

    return (
        <SnackbarProvider
            maxSnack={1}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
            autoHideDuration={2000}
        >
            <Box component={Stack} height={"100%"} width={"100%"} p={0.5}>

                <FormControl
                    variant="filled"
                    size="small"
                    sx={{
                        minWidth: "150px",
                        mr: 1.5,
                        alignSelf: "flex-end"
                    }}
                >
                    <InputLabel>Export</InputLabel>
                    <Select
                        value={exportFile}
                        // onChange={(e) => setExportFile(e.target.value)}
                        onChange={handleExportFileChange}
                        label="Export"
                        renderValue={(selected) => {
                            if (selected === 'none') {
                                return "Export";
                            }
                            return selected;
                        }}
                        sx={{
                            height: "35px",

                        }}
                    >
                        {exportList.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Stack height={"calc(100% - 32px)"} direction={"row"} gap={1} p={1}>

                    <Box component={Paper} width={"80%"} height={"100%"} p={1}>
                        <MerchantsDetails
                            selectedProfitCenter={selectedProfitCenter}
                            setSelectedProfitCenter={setSelectedProfitCenter}
                            setSelectedMerchantProvider={setSelectedMerchantProvider}
                            date={date}
                            setDate={setDate}
                        />
                    </Box>

                    <Box component={Paper} width={"20%"} height={"100%"}>
                        <ChargeBacksDetails
                            selectedProfitCenter={selectedProfitCenter}
                            selectedMerchantProvider={selectedMerchantProvider}
                            dateRange={dateRange}
                            setDateRange={setDateRange}
                            date={pendingChargeBackDate}
                            setDate={setPendingChargeBackDate}
                        />
                    </Box>

                </Stack>

            </Box>
            {loading && <Loader loading={loading} />}
        </SnackbarProvider>
    )

};

export default MerchantWidget;